<template>
    <div class="buttongroup">
      <button 
        type="button"
        v-for="(option, index) in options" 
        v-bind:key="index"
        v-html="option"
        v-bind:class="{isSelected : value == index}"
        v-on:click="$emit('input', Number(index))">
      </button>
   </div>
</template>

<script>
  export default {
    name: 'buttongroupComponent',
    data() {
      return {
        options : {
          1 : '1',
          2 : '2',
          3 : '3',
          4 : '4',
          5 : '5',
          6 : '6 of meer',
        }
      };
    },
    props: {
        value: {
            type: Number,
            default: 2
        },
    },
  }
</script>

<style scoped lang="scss">
  .buttongroup {
    margin-top: 8px;
    button {
      min-width: 44px;
      min-height: 44px;
      margin-right: 8px;
      padding: 0 15px;
      border: 0 solid;
      border-radius: 0;
      color: $color-primary;
      font-family: $font-base;
      font-size: 1em;
      font-weight: bold;
      user-select: none;
      cursor: pointer;
      transition: all .350s;

      &:focus, &:hover {
        outline: 0;
        box-shadow: 1px 1px 4px rgba(0,0,0,0.2);
      }

      &.isSelected {
        color: white;
        background-color: $color-primary;
        transition: all .350s;
      }
    }
  }
</style>
